import React from 'react';
import { createUseStyles, clsx } from '@pushpay/styles';
import { useResponsiveProp } from '@pushpay/theming';
import { memo } from '@pushpay/types';
const useBoxSpaceStyles = createUseStyles(theme => ({
  root: ({
    space
  }) => ({
    width: '100%',
    padding: theme.SPACING[space]
  })
}));
const useBoxSpaceHVStyles = createUseStyles(theme => ({
  root: ({
    spaceH,
    spaceV
  }) => ({
    width: '100%',
    padding: `${theme.SPACING[spaceV]} ${theme.SPACING[spaceH]}`
  })
}));

const BoxSpace = ({
  component: Component = 'div',
  space: spaceProp = 'NONE',
  className: classNameProp,
  classes: classesProp,
  ...rest
}) => {
  const space = useResponsiveProp(spaceProp);
  const classes = useBoxSpaceStyles(classesProp, {
    space
  });
  const className = clsx(classNameProp, classes.root);
  return /*#__PURE__*/React.createElement(Component, Object.assign({
    className: className
  }, rest));
};

const BoxSpaceHV = ({
  component: Component = 'div',
  spaceH: spaceHProp = 'NONE',
  spaceV: spaceVProp = 'NONE',
  className: classNameProp,
  classes: classesProp,
  ...rest
}) => {
  const spaceH = useResponsiveProp(spaceHProp);
  const spaceV = useResponsiveProp(spaceVProp);
  const classes = useBoxSpaceHVStyles(classesProp, {
    spaceH,
    spaceV
  });
  const className = clsx(classNameProp, classes.root);
  return /*#__PURE__*/React.createElement(Component, Object.assign({
    className: className
  }, rest));
};

export const Box = memo(function Box(props) {
  const {
    space,
    spaceH,
    spaceV,
    ...rest
  } = props;
  return space || !space && !spaceH && !spaceV ? /*#__PURE__*/React.createElement(BoxSpace, Object.assign({
    space: space
  }, rest)) : /*#__PURE__*/React.createElement(BoxSpaceHV, Object.assign({
    spaceH: spaceH,
    spaceV: spaceV
  }, rest));
});